import { connect } from "react-redux";

import type { AccountReduxState } from "@app/modules/account";

import type { OwnProps } from "./billing-address-section";

import { BillingAddressSection as BillingAddressSectionComponent } from "./billing-address-section";

const mapStateToProps = (state: AccountReduxState, _ownProps: OwnProps) => {
  const { user_billing_address, user } = state;
  return {
    user_billing_address,
    user_id: user.id
  } as const;
};

export const BillingAddressSection = connect(mapStateToProps)(
  BillingAddressSectionComponent
);
